import i18n from '../../../../../../../i18n';
import { ADYEN_APM_FIELDS, DynamicFieldsAdyen } from '../../../types';
import { parseAddress } from '../../../utils';

function isFullName(value: string): boolean {
  return value.trim().split(/\s+/).length === 2;
}

function isOnlyLetters(value: string): boolean {
  return /^[a-zA-Z\s]+$/.test(value);
}

export function setRequiredFieldError(errors: Record<string, string>, field: DynamicFieldsAdyen) {
  errors[field.apm_key] = i18n.t('checkout.fieldErrors.incomplete', {
    field: i18n.t(`checkout.${field.apm_key}`),
  });
  return;
}

export function isRequiredFieldMissing(value: string, field: DynamicFieldsAdyen): boolean {
  const isBillingAddressField = field.apm_key === ADYEN_APM_FIELDS.BILLING_ADDRESS;
  return !value && !isBillingAddressField;
}

export function validateDynamicForm(
  values: Record<string, string>,
  formFields: DynamicFieldsAdyen[]
): Record<string, string> {
  const errors: Record<string, string> = {};
  formFields.forEach((field) => {
    const value = values[field.apm_key];
    if (isRequiredFieldMissing(value, field)) {
      return setRequiredFieldError(errors, field);
    }
    if (value && field.validation) {
      const validationPattern = new RegExp(field.validation);
      if (field.apm_key === ADYEN_APM_FIELDS.SHOPPER_NAME) {
        const isValidCharacters = isOnlyLetters(value);
        const hasFullName = isFullName(value);
        if (!isValidCharacters || !hasFullName) {
          errors[field.apm_key] = i18n.t(`checkout.fieldErrors.${field.apm_key}`);
        }
      } else {
        if (!validationPattern.test(value)) {
          errors[field.apm_key] = i18n.t(`checkout.fieldErrors.${field.apm_key}`);
        }
      }
    }
  });

  return errors;
}

export function validateBillingAddressUtil({
  hasAddressField,
  shouldShowTaxCalculationField,
  AddressElementRef,
  countryCode2,
}: {
  hasAddressField: boolean;
  shouldShowTaxCalculationField: boolean;
  AddressElementRef: any;
  countryCode2: string;
}) {
  if (!(hasAddressField || shouldShowTaxCalculationField) || !AddressElementRef.current?.values) {
    return { isValid: true, error: undefined };
  }

  const addressValues = AddressElementRef.current.values;
  const billingAddressData = {
    address: addressValues.address || '',
    zipCode: addressValues.zipCode || '',
  };

  try {
    parseAddress(billingAddressData, countryCode2);
    return { isValid: true, error: undefined };
  } catch (error) {
    const validationError = error instanceof Error ? error.message : 'Invalid billing address';
    return { isValid: false, error: validationError };
  }
}
